export default "__VITE_ASSET__CTGTHfEt__"